import React from 'react';
import { Menu } from 'evergreen-ui';

const SourceVersionMenu = ({ onEditClick, onDeleteClick }: any) => {
  return (
    <Menu>
      <Menu.Group>
        <Menu.Item onSelect={onEditClick}>Edit version</Menu.Item>
      </Menu.Group>
      <Menu.Divider />
      <Menu.Group>
        <Menu.Item intent="danger" onSelect={onDeleteClick}>
          Delete version...
        </Menu.Item>
      </Menu.Group>
    </Menu>
  );
};

export default SourceVersionMenu;
